import React from 'react';
import { Link } from 'react-router-dom';

const PageLayout = ({ title, subtitle, backTo, backLabel, actions, children }) => {
  const isLcars = document.documentElement.getAttribute('data-theme') === 'lcars' || localStorage.getItem('theme') === 'lcars';

  return (
    <div className="bg-slate-50/50 min-h-[calc(100vh-64px)] relative flex flex-col">
      {!isLcars && (
        <>
          {/* Dynamic brand-consistent background mesh blobs */}
          <div className="absolute top-0 left-0 right-0 h-[600px] bg-gradient-to-b from-primary-light/30 via-transparent to-transparent pointer-events-none -z-10 animate-fade" />
          <div className="absolute top-[10%] left-[5%] w-[450px] h-[450px] rounded-full bg-primary/10 blur-[130px] pointer-events-none -z-10 animate-pulse duration-[8s]" />
          <div className="absolute top-[45%] right-[5%] w-[550px] h-[550px] rounded-full bg-primary-light/30 blur-[145px] pointer-events-none -z-10 animate-pulse duration-[10s]" />
        </>
      )}

      <div className="flex-1 max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8 pt-8 pb-16 relative z-10">
        {backTo && (
          <div className="mb-5">
            <Link to={backTo} className="text-sm font-semibold text-primary hover:text-primary-hover inline-flex items-center gap-1.5 transition-colors">
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
              {backLabel || 'Back'}
            </Link>
          </div>
        )}

        <div className="border-b border-slate-200/80 pb-5 mb-8">
          <div className="md:flex md:items-center md:justify-between md:space-x-5">
            <div className="flex items-start space-x-5">
              <div>
                <h1 className="text-xl font-bold text-slate-900 tracking-tight sm:text-2xl">
                  {title}
                </h1>
                {subtitle && (
                  <p className="text-sm font-medium text-slate-500 mt-2 max-w-2xl leading-relaxed">
                    {subtitle}
                  </p>
                )}
              </div>
            </div>
            {actions && (
              <div className="mt-6 md:mt-0 flex flex-shrink-0 items-center gap-3">
                {actions}
              </div>
            )}
          </div>
        </div>

        <div className="animate-fade">
          {children}
        </div>
      </div>
    </div>
  );
};

export default PageLayout;
